export const BLOCKED_NUMBERS = 'Blocked Numbers';

export const ADD_BLOCKED_PHONE_NUMBER = 'Add New Blocked Phone Number';
export const UNBLOCK_PHONE_NUMBER = 'Unblock Phone Number';
export const PHONE_NUMBER = 'Phone Number';
export const INVALID_PHONE_MESSAGE = "Invalid phone number";
export const BLOCK_ANONYMOUS_CALLERS = "Block anonymous callers";
export const BLOCKED_NUMBER = 'blockedNumber';
export const IS_ANONYMOUS_CALLER = 'isAnonymousCallerBlocked';